import React, { useState } from "react";
import { Grid, Icon } from "semantic-ui-react";
import { passwordRegex } from "../../utils/regex";
const Password = ({ getError, getValue }) => {
  const [showPass, setShowPass] = useState(false);
  const [showPass2, setShowPass2] = useState(false);
  const [password, setPassword] = useState(null);
  const [password2, setPassword2] = useState(null);
  const handlePasswordChange = (data) => {
    if (passwordRegex.test(data)) {
      setPassword(data);
      getError(false);
    } else {
      getError(
        "Passwords must be 8-30 characters long and contain an Upper Case, Lower Case, Number, and Special Character."
      );
    }
  };
  const handlePassword2Change = (data) => {
    if (data === password) {
      setPassword2(data);
      getError(false);
    } else {
      getError("Password does not match");
    }
  };
  const handleBlur = () => {
    if (
      passwordRegex.test(password) &&
      passwordRegex.test(password2) &&
      password === password2
    ) {
      getValue(password);
      getError(false);
    } else {
      getError("Password is not valid and not matching");
    }
  };
  return (
    <>
      <Grid.Column mobile={16} tablet={8} computer={8}>
        <div className="form-group">
          <label htmlFor="password">
            Password <span className="required">*</span>
          </label>
          <div className="group-field">
            <input
              id="password"
              type={showPass ? "text" : "password"}
              placeholder="Enter password"
              autoComplete="off"
              onChange={(e) => handlePasswordChange(e.target.value)}
              onBlur={handleBlur}
            />
            <Icon
              className="password-icon"
              name={`eye ${showPass ? "slash" : ""}`}
              onClick={() => setShowPass(!showPass)}
            />
          </div>
        </div>
      </Grid.Column>
      <Grid.Column mobile={16} tablet={8} computer={8}>
        <div className="form-group">
          <label htmlFor="cpassword">
            Confirm Password <span className="required">*</span>
          </label>
          <div className="group-field">
            <input
              id="cpassword"
              type={showPass2 ? "text" : "password"}
              placeholder="Enter confirm password"
              autoComplete="off"
              onChange={(e) => handlePassword2Change(e.target.value)}
              onBlur={handleBlur}
            />
            <Icon
              className="password-icon"
              name={`eye ${showPass2 ? "slash" : ""}`}
              onClick={() => setShowPass2(!showPass2)}
            />
          </div>
        </div>
      </Grid.Column>
    </>
  );
};

export default Password;
